import React, { useState } from "react";
import Header from "../../../../shared/modules/header/Header";
import { Link } from "react-router-dom";
import Menu from "../../../../shared/modules/menu/Menu";

const Service = () => {
  const [activeTab, setActiveTab] = useState("Staffs");
  return (
    <div>
      <Header Header={""} />
      <div style={{ display: "flex" }}>
        <div>
          <Menu />
        </div>
        <div>
          <div className="service-container">
            <h1 className="service-header">
              <div className="service-bar">
                <ul className="staff-alignment-saloon">
                  <Link to={"/v1/saloon-Home"}>
                    <li
                      className={activeTab === "Staffs" ? "active" : ""}
                      onClick={() => setActiveTab("Staffs")}
                    >
                      Services
                    </li>
                  </Link>
                  <Link to={"/v1/saloon-service"}>
                    <li
                      className={activeTab === "Services" ? "active" : ""}
                      onClick={() => setActiveTab("Services")}
                    >
                       Products
                    </li>
                  </Link>
                </ul>
              </div>
            </h1>
          </div>
          <div>
            <h1>welcome</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
